import { Component } from "@angular/core";

import { SvgMixinLargeComponent } from "../svg-large-mixin.component";

@Component({
  selector: "med-icon-plus-large",
  templateUrl: "./med-icon-plus-large.component.html",
})
export class MedIconPlusLargeComponent extends SvgMixinLargeComponent { }
